export const DEFAULT_QUEUE_FILTERS = Object.freeze({
  organisation: '',
  organisationObj: null,
  botNumber: '',
  botNumberObj: null,
  templateId: '',
  templateObj: null,
  page: 0,
  limit: 10,
});

export function applyQueueFilterPatch(filters = {}, patch = {}) {
  const next = {
    ...filters,
    ...patch,
    page: Object.prototype.hasOwnProperty.call(patch, 'page') ? patch.page : 0,
  };

  if (
    Object.prototype.hasOwnProperty.call(patch, 'organisation')
    && patch.organisation !== filters.organisation
  ) {
    if (!Object.prototype.hasOwnProperty.call(patch, 'botNumber')) {
      next.botNumber = '';
      next.botNumberObj = null;
    }
    if (!Object.prototype.hasOwnProperty.call(patch, 'templateId')) {
      next.templateId = '';
      next.templateObj = null;
    }
  }

  if (
    Object.prototype.hasOwnProperty.call(patch, 'botNumber')
    && patch.botNumber !== filters.botNumber
    && !Object.prototype.hasOwnProperty.call(patch, 'templateId')
  ) {
    next.templateId = '';
    next.templateObj = null;
  }

  return next;
}

export function clearQueueFilterChip(filters = {}, key) {
  if (key === 'organisation') {
    return applyQueueFilterPatch(filters, {
      organisation: '',
      organisationObj: null,
    });
  }
  if (key === 'botNumber') {
    return applyQueueFilterPatch(filters, {
      botNumber: '',
      botNumberObj: null,
    });
  }
  if (key === 'template') {
    return applyQueueFilterPatch(filters, {
      templateId: '',
      templateObj: null,
    });
  }
  return { ...filters };
}
